import styled from 'styled-components';

const ValueContainer = styled.div<any>`
  ${({ width = '50%' }) => {
    return `width: ${width}`;
  }};
`;

export default ValueContainer;
